import { useCallback } from 'react';
import BaseInputField from './BaseInputField/BaseInputField';

export interface ISocialSecurityInputProps {
    maskedSocialSecurity: string;
    setMaskedSocialSecurity: React.Dispatch<React.SetStateAction<string>>;
    socialSecurity: string;
    setSocialSecurity: React.Dispatch<React.SetStateAction<string>>;
    disabled: boolean;
}
const SocialSecurityInput = (props: ISocialSecurityInputProps) => {
    const { maskedSocialSecurity, setMaskedSocialSecurity, socialSecurity, setSocialSecurity } =
        props;

    const handleSocialSecurity = useCallback(
        (value: string) => {
            const newInput = value.substring(maskedSocialSecurity.length);
            if (isNaN(parseInt(newInput)) && newInput != '') return;

            if (newInput == '') {
                setSocialSecurity(socialSecurity.substring(0, socialSecurity.length - 1));
            } else if (socialSecurity.length < 9) setSocialSecurity(socialSecurity + newInput);

            let currentMaskedValue;
            switch (value.length) {
                case 3:
                case 6:
                    currentMaskedValue =
                        newInput == '' ? value.substring(0, value.length - 1) : value + '-';
                    break;
                default:
                    currentMaskedValue = newInput == '' ? value.substring(0, value.length) : value;
                    break;
            }
            setMaskedSocialSecurity(
                currentMaskedValue.substring(0, 7).replace(/\d/g, '#') + value.substring(7, 11)
            );
        },
        [socialSecurity, maskedSocialSecurity]
    );

    return (
        <BaseInputField
            name={'socialSecurityNumber'}
            label={'Social Security Number'}
            required
            onChange={handleSocialSecurity}
            value={maskedSocialSecurity}
            autoComplete={'off'}
            disabled={props.disabled}
        />
    );
};

export default SocialSecurityInput;
